import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getSalesReportsRequest = () => ({
  type: 'GET_SALES_REPORTS_REQUEST',
})

export const getSalesReportsSuccess = (data) => ({
  type: 'GET_SALES_REPORTS_SUCCESS',
  data,
})

export const getSalesReportsFailure = (error) => ({
  type: 'GET_SALES_REPORTS_FAILURE',
  error,
})

export const getSalesReports = (startDate, endDate) => {
  return (dispatch) => {
    dispatch(getSalesReportsRequest())

    fetch(
      `${URL.BASE_URL + URL.END_POINT.salesreports}?startDate=${startDate}&endDate=${endDate}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
      },
    )
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getSalesReportsSuccess(data))
      })
      .catch((error) => {
        dispatch(getSalesReportsFailure(error.message))
        toast(error.message, { type: 'error' })
      })
  }
}

const initialAppState = {
  salesReportsData: [],
  headersData: [],
  rowsData: [],
  loadingSalesReportsData: false,
  errorSalesReportsData: null,
}

export const salesReportsReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case 'GET_SALES_REPORTS_REQUEST':
      return {
        ...state,
        loadingSalesReportsData: true,
        errorSalesReportsData: null,
      }
    case 'GET_SALES_REPORTS_SUCCESS':
      return {
        ...state,
        salesReportsData: action.data.data,
        headersData: action.data.headers,
        rowsData: action.data.rows,
        loadingSalesReportsData: false,
        errorSalesReportsData: null,
      }
    case 'GET_SALES_REPORTS_FAILURE':
      return {
        ...state,
        loadingSalesReportsData: false,
        errorSalesReportsData: action.error,
      }
    default:
      return state
  }
}
